import { Promise } from 'es6-promise';

import { PM } from '../../constants';
import { pmRequest } from './requestFactory';
import FSA from '../FSA';

interface ISystemSoftware {
    nodeId?: string
}

interface IParams {
    containerIds: string[],
    start: Date,
    end: Date,
}

function fetchSoftware(requesterId: string, params: IParams): Promise<ISystemSoftware[]> {
    const { containerIds, start, end } = params;

    const query = {
        ContainerIdList: containerIds,
        From: start.toISOString(),
        To: end.toISOString(),
    };

    return pmRequest.post(`container/report`, query).then((software) => {
        return software.reduce((r, cSoftware) => {
            r[cSoftware.ContainerId] = cSoftware.PatchList;
            return r;
        }, {});
    });
}

function listSoftware(requesterId: string, params: IParams): Function {
    return dispatch => {
        dispatch(new FSA(PM.FETCH_SOFTWARE_REQUEST).addMeta({ requesterId }).data);

        return fetchSoftware(requesterId, params).then((software: any[]) => {
            return dispatch(new FSA(PM.FETCH_SOFTWARE_SUCCESS).addPayload(software).addMeta({ requesterId }).data);
        }, err => {
            dispatch(new FSA(PM.FETCH_SOFTWARE_FAILURE).addError(err).addMeta({ requesterId }).data);
            throw err;
        });
    }
}

export {
    ISystemSoftware,
    fetchSoftware,
    listSoftware,
};


// WEBPACK FOOTER //
// ./src/actions/pm/Software.ts